import React, {Component} from 'react';
import {connect} from 'react-redux';
import Head from '../../../Structure/components/Head/Head';
import Alert from 'react-s-alert';
import AlertsConteiner from '../../../Shared/components/Alerts/AlertsConteiner';
import Input from '../../../Shared/components/Forms/input/input';
import InputPassword from '../../../Shared/components/Forms/input/inputPassword';
import {browserHistory, Link} from 'react-router';
import WaitBlock from "../../../Shared/components/Alerts/WaitBlock";
import {changeStepWaitBlock, showWaitBlock} from "../../../Structure/actions/actionsStructure";
import {login} from "../../actions/actionsAdmin";
import {
    PATH_BUSCADOR_ANIMALES_ADMIN,
    PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO,
    PATH_BUSCADOR_ANIMALES_CONTACTA_CON_NOSTROS
} from "../../../../App/RouterAdopta";

class LoginPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            user: "",
            password: ""
        };

        this.login = this.login.bind(this);

        this.user = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateLogin",
            iconSpan: "icon-login-color las la-lg la-user",
            columns: "col-lg-12",
            id: "user",
            type: "username",
            placeHolder: "Email",
            methodChange: this.changeUser.bind(this)
        };

        this.password = {
            inlineIcon: "form-control-inline-icon inline-icon-right",
            controlValidate: "validateLogin",
            iconSpan: "icon-login-color las la-lg la-key",
            columns: "col-lg-12",
            id: "password",
            type: "password",
            placeHolder: "Contraseña",
            methodChange: this.changePassword.bind(this)
        };

        this.EventWaitBlock = this.EventWaitBlock.bind(this);

    }

    changeUser(value, elementId) {
        this.setState({
            user: value
        });
    }

    changePassword(value, elementId) {
        this.setState({
            password: value
        });
    }

    validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    login(e) {
        //Comprobar que todos los campos son correctos.
        let errorMessage = "";
        let user = $('#user');
        let password = $('#password');

        if (user.val() === "") {
            user.removeClass('formInputError').addClass('formInputError');
            if (errorMessage === "") {
                errorMessage = "Email";
            } else {
                errorMessage += ", Email";
            }
        } else {
            if (!this.validateEmail(user.val())) {
                user.removeClass('formInputError').addClass('formInputError');
                if (errorMessage === "") {
                    errorMessage = "Email no válido";
                } else {
                    errorMessage += ", email no válido";
                }
            } else {
                user.removeClass('formInputError')
            }
        }

        if (password.val() === "") {
            password.removeClass('formInputError').addClass('formInputError');
            if (errorMessage === "") {
                errorMessage = "Contraseña";
            } else {
                errorMessage += ", contraseña";
            }
        } else {
            password.removeClass('formInputError')
        }

        Alert.closeAll();
        if (errorMessage !== "") {
            e.preventDefault();
            Alert.warning('Los siguientes campos son obligatorios: ' + errorMessage, {
                position: 'top-right',
                effect: 'slide',
                timeout: 60000,
                customFields: {
                    messageItem: 2,
                    showIconClosed: true,
                    icon: "las la-2x la-exclamation-triangle",
                    // type: "warning"
                }
            });
        } else {
            e.preventDefault();
            this.props.changeWaitBlock(true);
        }
    }

    EventWaitBlock(event) {
        if (event === "go") {
            this.props.login(this.state);
        } else {
            if (this.props.stepWaitBlock === 200) {
                browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN);
            } else {
                Alert.error('' + this.props.errorWaitBlock, {
                    position: 'top-right',
                    effect: 'slide',
                    timeout: 8000,
                    customFields: {
                        messageItem: 2,
                        showIconClosed: true,
                        icon: "las la-2x la-exclamation-triangle",
                        type: "info"
                    }
                });

            }
            this.props.changeStepWaitBlock(0);
            this.props.changeWaitBlock(false);
        }

    }

    goSignUp() {
        let animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        $('.page-login').removeClass('animated-400ms fadeIn').addClass('animated-400ms fadeOut').one(animationEnd, () => {
            browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO + '?utm_medium=login');
        });
    }

    render() {
        return (
            <div>
                <Head
                    previousPath={"login"}
                />
                {this.props.showWaitBlock &&
                <WaitBlock
                    message={"Espere por favor..."}
                    methodChange={this.EventWaitBlock}
                />
                }
                <div className="page-login main-content">
                    <div className="container">
                        <div className="page-login__wrap">
                            <h2 className="page-login__heading">¡Nos alegra verte de vuelta!</h2>
                            <p className="page-login__description">
                                <br/>
                                "Salvar un animal no cambiara el mundo pero cambiará la vida de ese animal"
                            </p>
                            <form action="#" className="page-login__form">
                                <div className="row justify-content-center">
                                    <Input
                                        configInput={this.user}
                                    />
                                </div>
                                <div className="row justify-content-center">
                                    <InputPassword
                                        configInput={this.password}
                                    />
                                </div>
                                {/*<div className="row justify-content-left">*/}
                                {/*    <div className="col-lg-12">*/}
                                {/*        <a href="#" className="page-login__forgot-password">¿Has olvidado la contraseña?</a>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                <div className="row justify-content-center">
                                    <div className="col-lg-12">
                                        <div className="form-group mb-0">
                                            <button onClick={this.login} type="button"
                                                    className="btn btn-primary btn-block page-login__submit-btn">Login
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <br/>
                                <div className="row justify-content-center">
                                    <Link to={PATH_BUSCADOR_ANIMALES_CONTACTA_CON_NOSTROS + "?utm_medium=login"}
                                          className="page-login__forgot-password">Contactar con soporte al
                                        cliente</Link>
                                </div>
                                <br/>
                                {/*<footer className="page-login__form-footer">*/}
                                {/*    <span>¿No estás registrado?</span>*/}
                                {/*    <a href="#" onClick={() => this.goSignUp()}*/}
                                {/*       className="btn btn-outline-secondary page-login__signup-btn">Registrar*/}
                                {/*        protectora</a>*/}
                                {/*</footer>*/}

                            </form>
                            <br/>
                            <div className="row justify-content-center">
                                ¿Quieres publicar los animales de tu protectota o asociación?
                                <Link to={PATH_BUSCADOR_ANIMALES_ADMIN_REGISTRO + "?utm_medium=login"}
                                      className="page-login__forgot-password"
                                      style={{marginLeft: 6}}> Si, quiero registrarme!</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <Alert stack={true} html={true} contentTemplate={AlertsConteiner}/>
            </div>
        );
    }

    componentWillMount() {
        //console.log("LoginPage::componentWillMount()");
        //console.log("this.props.isLogin = '" + this.props.isLogin + "'");
        if (this.props.isLogin) {
            //console.log("LoginPage::componentWillMount() -> Cambio de ruta -> " + PATH_BUSCADOR_ANIMALES_ADMIN);
            browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN);
        } else {


            //Initial scroll
            let element = $("body");
            if (element.length !== 0) {
                //console.log("Haciendo scrollTop");
                $('body,html').stop(true, true).animate({                    scrollTop: element.offset().top                }, 100);
            }

            this.props.changeWaitBlock(false);
            this.props.changeStepWaitBlock(0);
        }
    }

    componentDidMount() {
        // $('.page-login').addClass('animated-400ms fadeIn');
        $('.page-login').show();
        let animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

        if (!this.props.showHead) {
            $('.header-topbar').addClass('animated-400ms fadeInDown').one(animationEnd, () => {
                $('.header-topbar').removeClass('animated-400ms fadeInDown');
            });
            //$('.header-topbar').css("visibility", "visible");
        } else {
            $('.header-topbar').removeClass('animated-400ms fadeInDown');
            //$('.header-topbar').css("visibility", "visible");
        }

        if (!this.props.showFooter) {
            //$('.footer-default').addClass('animated-400ms fadeIn');
            $('.footer-default').show();
        } else {
            //$('.footer-default').removeClass('animated-400ms fadeIn');
            $('.footer-default').show();
        }


    }

    componentDidUpdate() {
        if (this.props.showWaitBlock) {
            $('#modal-container').removeClass('out').addClass("one");
            $('body').addClass('modal-active');
        } else {
            $('body').removeClass('modal-active');
        }
    }

}

function mapStateToProps(state) {
    return {
        showHead: state.structureControl.showHead,
        showFooter: state.structureControl.showFooter,
        showWaitBlock: state.structureControl.showWaitBlock,
        stepWaitBlock: state.structureControl.stepWaitBlock,
        errorWaitBlock: state.structureControl.errorWaitBlock,
        isLogin: state.access.isLogin
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {changeWaitBlock: showWaitBlock, changeStepWaitBlock, login})(LoginPage)
